import { render, staticRenderFns } from "./SecondHands.vue?vue&type=template&id=0aa044e5&"
import script from "./SecondHands.vue?vue&type=script&lang=js&"
export * from "./SecondHands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports